export const HEADER_SWITCH = {
  init: function () {
    const el = document.querySelector('.l-header__fixed')
    if (!el) return

    let lastScroll = 0
    const threshold = 5

    window.addEventListener('scroll', () => {
      if (document.body.classList.contains('is-gnav-open')) return

      const current = window.pageYOffset
      const diff = current - lastScroll

      if (Math.abs(diff) < threshold) return

      if (diff > 0 && current > 100) {
        el.classList.add('is-hide')
      } else {
        el.classList.remove('is-hide')
      }

      lastScroll = current
    })
  },
}
